var _ToastServiceInit_instances, _ToastServiceInit_toasts, _ToastServiceInit_hashGenerator, _ToastServiceInit_toast;
import { __classPrivateFieldGet } from "tslib";
import { writable } from 'svelte/store';
import { HashGenerator } from '../util/hash/HashGenerator';
class ToastServiceInit {
    constructor() {
        _ToastServiceInit_instances.add(this);
        _ToastServiceInit_toasts.set(this, writable([]));
        _ToastServiceInit_hashGenerator.set(this, new HashGenerator());
    }
    get toasts() {
        return __classPrivateFieldGet(this, _ToastServiceInit_toasts, "f");
    }
    toastText(toastText) {
        const toast = {
            hash: __classPrivateFieldGet(this, _ToastServiceInit_hashGenerator, "f").generate('toast'),
            text: toastText,
        };
        __classPrivateFieldGet(this, _ToastServiceInit_instances, "m", _ToastServiceInit_toast).call(this, toast);
    }
}
_ToastServiceInit_toasts = new WeakMap(), _ToastServiceInit_hashGenerator = new WeakMap(), _ToastServiceInit_instances = new WeakSet(), _ToastServiceInit_toast = function _ToastServiceInit_toast(toast) {
    __classPrivateFieldGet(this, _ToastServiceInit_toasts, "f").update((toasts) => [...toasts, toast]);
    setTimeout(() => {
        __classPrivateFieldGet(this, _ToastServiceInit_toasts, "f").update((toasts) => toasts.filter((t) => t !== toast));
    }, 3000);
};
export const ToastService = new ToastServiceInit();
